import Facilities                                         from "../../../domain/facility/Facilities";
import { ACTION_TYPE, FacilityAction, FacilitySetAction } from "./FacilityAction";

const facilityReducer = (state: Facilities = new Facilities(), action: FacilityAction): Facilities => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.SET_FACILITIES:
      return reduceSetFacilities(action as FacilitySetAction);
  }
};

const reduceSetFacilities = (action: FacilitySetAction): Facilities => {
  return action.facilities;
};

export default facilityReducer;